import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import { SelectChangeEvent } from '@mui/material';

interface DropDownMultiselectProps {
	data: any[];
	selectedData: any[];
	handleSelectedData: (data: any[]) => void;
	error?: string;
	size: 'small';
}

const TestKitsDropdownMultiSelect: React.FC<DropDownMultiselectProps> = ({
	data,
	selectedData,
	handleSelectedData,
	error,
	size,
}) => {
	const [currentSelections, setCurrentSelections] = useState<string[]>([]);

	const handleChange = (event: SelectChangeEvent<typeof selectedData>) => {
		const value = event.target.value as string[];
		setCurrentSelections(value);
	};

	const handleClose = () => {
		handleSelectedData(
			data.filter((item) => currentSelections.includes(item.testKitName))
		);
	};

	useEffect(() => {
		setCurrentSelections(selectedData?.map((item) => item.testKitName) || []);
	}, [selectedData]);

	return (
		<div>
			<FormControl sx={{ width: 360 }} error={!!error}>
				<Select
					size={size}
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					multiple
					value={currentSelections}
					onChange={handleChange}
					onClose={handleClose}
					renderValue={(selected) => selected.join(', ')}
					MenuProps={{
						PaperProps: {
							style: { maxHeight: 48 * 4.5 + 8, width: 250 },
						},
					}}
				>
					{data?.map((item, index) => (
						<MenuItem
							key={`${item.testKitName}-${index}`}
							value={item.testKitName}
						>
							<Checkbox
								checked={currentSelections.includes(item.testKitName)}
							/>
							<ListItemText primary={item.testKitName} />
						</MenuItem>
					))}
				</Select>
				<FormHelperText>{error}</FormHelperText>
			</FormControl>
		</div>
	);
};

export default TestKitsDropdownMultiSelect;